import { POcomparisonTypes } from './actionTypes';

export const getComodityListByPO = (payload: any) => ({
  type: POcomparisonTypes.GET_COMODITY_LIST_BY_PO,
  payload,
});

export const getComodityListByPOSuccess = (payload: any) => ({
  type: POcomparisonTypes.GET_COMODITY_LIST_BY_PO_SUCCESS,
  payload,
});

export const getComodityListByPOFail = (error: any) => ({
  type: POcomparisonTypes.GET_COMODITY_LIST_BY_PO_FAIL,
  payload: error,
});
